// import Carousel from "@brainhubeu/react-carousel";
// import "@brainhubeu/react-carousel/lib/style.css";
import { useCallback, useState } from 'react';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import './style.scoped.css';
import { sendOpenNewWebview, gaTrackingAndLogAction } from 'src/utils';
import {
  BUYING_PROCESS,
  BUYING_PROCESS_STEP,
  BUYING_PROCESS_TRACKING, LOCAL_ACCOUNT, LOCAL_ACCOUNT_STEP,
  LOCAL_ACCOUNT_TRACKING,
  PATH,
  CAMPAIGN_CODES,
  ON_TO_OFF_ACTION_TYPE,
} from 'src/constants';
import { useHistory } from 'react-router';
import { gaTrackEvent } from '../../api';
import UserInfoService from '../../utils/UserInfoService';
// import Carousel from '@brainhubeu/react-carousel';

const Banner = (props) => {
  const { data } = props;
  const [selectedItem, setSelectedItem] = useState(0);
  const history = useHistory();
  const _handlePressItem = useCallback((item) => {
    const isSpecialOfferLocalAccountPath = item.link.includes(
      PATH.SPECIAL_OFFERS_CAMPAIGN
    );
    if (isSpecialOfferLocalAccountPath) {
      gaTrackingAndLogAction({
        pub: LOCAL_ACCOUNT_TRACKING,
        event: LOCAL_ACCOUNT[LOCAL_ACCOUNT_STEP.LOCAL_ACCOUNT_CLICK_BANNER],
        eventDirectory: CAMPAIGN_CODES.LOCAL_ACCOUNT,
        actionType: ON_TO_OFF_ACTION_TYPE,
      }).finally(() => {
        history.push(PATH.SPECIAL_OFFERS_CAMPAIGN);
      });
    } else {
      sendOpenNewWebview(item);
    }
  }, []);

  const _renderBannerItem = (item, index) => {
    return (
      <div
        className="image"
        key={item.id}
        onClick={() => _handlePressItem(item)}
      >
        <img src={item.photo} className="image object-cover" />
      </div>
    );
  };

  const _handeChangeSelectedItem = useCallback(
    (index, item) => {
      setSelectedItem(index);
    },
    [setSelectedItem]
  );

  if (!data || data.length == 0) return <div />;

  return (
    <div>
      <Carousel
        showThumbs={false}
        showStatus={false}
        showArrows={false}
        autoPlay={true}
        infiniteLoop={true}
        interval={3000}
        emulateTouch={true}
        stopOnHover={false}
        showIndicators={false}
        selectedItem={selectedItem}
        onChange={_handeChangeSelectedItem}
        autoFocus={true}
        swipeable={true}
      >
        {data.map(_renderBannerItem)}
      </Carousel>
      {data && data.length > 1 && (
        <div className="flex flex-row items-center justify-center mt-2 w-full">
          {data.map((item, index) => {
            if (index == selectedItem) {
              return (
                <div
                  className="w-2 h-2 bg-primaryVariant inline-block rounded-full mr-1.5"
                  key={index}
                />
              );
            }
            return (
              <div
                className="w-1 h-1 bg-primaryVariant rounded-full inline-block opacity-25  mr-1.5"
                key={index}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Banner;
